import styled from "@emotion/styled";
import theme from "../../theme";

const UserDetail = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;
const Content = styled.section`
  padding-top: 50px;
  grid-column: 2 / 12;
  display: flex;
  flex-direction: column;
`;

const UserInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  row-gap: 5.5rem;
  padding-top: 6.4rem;
`;
const UserInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 12;
  gap: 2rem;
  padding: 1rem 0;
  overflow-x: scroll;
  @media (min-width: ${theme.breakpoints.tablet}) {
    grid-column: span 6;
  }
  @media (min-width: ${theme.breakpoints.desktop}) {
    grid-column: span 4;
  }
`;
const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const EditWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 8.3rem;
`;

const Styled = {
  UserDetail,
  Content,
  UserInfo,
  UserInfoItem,
  EditWrapper,
  Loader,
};

export default Styled;
